export type TextHorizontalAlignType =
  | "content-align-x-left"
  | "content-align-x-mid-left"
  | "content-align-x-right"
  | "content-align-x-mid-right"
  | "content-align-x-left-wide"
  | "content-align-x-right-wide ";

export type VerticalAlignType =
  | "content-align-y-top"
  | "content-align-y-bottom";

export const getTextHorizontalAlignment = (styles: string[]) => {
  return styles.filter((style) =>
    style.includes("content-align-x"),
  ) as TextHorizontalAlignType[];
};

export const getTextVerticalAlign = (styles: string[]) => {
  return styles.filter((style) =>
    style.includes("content-align-y"),
  ) as VerticalAlignType[];
  [];
};
